import { render, staticRenderFns } from "./PaymentReview.vue?vue&type=template&id=62b62bfe"
import script from "./PaymentReview.vue?vue&type=script&lang=js"
export * from "./PaymentReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PaymentReview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62b62bfe')) {
      api.createRecord('62b62bfe', component.options)
    } else {
      api.reload('62b62bfe', component.options)
    }
    module.hot.accept("./PaymentReview.vue?vue&type=template&id=62b62bfe", function () {
      api.rerender('62b62bfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/review/PaymentReview.vue"
export default component.exports